export class EmployeeGridViewModel {
    constructor() {
        this.firstName = "";
        this.lastName = "";
        this.emailId = "";
    }
}
export default class EmployeeGridView extends EmployeeGridViewModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
